import { styled, Typography, Box, Grid, Button, Card } from '@mui/material';
import { useEffect } from 'react';
import Page from '../components/Page';
import { LoginForm } from '../components/authentication/login';
import loginImage from '../assets/images/loginimage.png';
import Logo from 'components/Logo';
import { useNavigate } from 'react-router-dom';
import { userTokenPersistence } from 'persistence';
import XinfinLogin from 'components/XinfinLogin';
import { useCoreTableState, useSubscriptionState } from 'state';

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
    background: 'transparent',
    height: '100vh'
  }
}));

const Login = () => {
  const navigate = useNavigate();
  const userToken = userTokenPersistence.get();

  useEffect(() => {
    if (userToken) {
      navigate('/home');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userToken]);

  // const { orgLogo } = useSubscriptionState();
  const { fetchOrganizations, orgnizations } = useCoreTableState();

  useEffect(() => {
    fetchOrganizations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Card
      sx={{
        mx: 'auto',
        backgroundColor: '#0D0D5E',
        width: '100%',
        height: 'auto',
        borderRadius: '8px',
        p: { xs: 2, sm: 4 },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          mb: '2rem',
          marginTop: 2
          // marginTop: '213.97px'
        }}
      >
        {orgnizations[0] && (
          <Box         
            sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            // position: 'absolute',
            top: '2%',
            left: '2%',
            width: '25%',
            height: 'auto',
            zIndex: 1
        }}>
         <Box
            component="img"
            src={orgnizations[0].logo}
            alt="Organization Logo"
            sx={{
              width: { xs: '5rem', sm: '6rem' },
              height: 'auto',
              mx: 'auto',
              display: 'block'
            }}
          />
          </Box>       
           )}
      </Box>

      <LoginForm />

      {/* <XinfinLogin /> */}
    </Card>
  );
};

export default Login;
